"use client";
import { useId } from "react";
//#region packages/@mantine/core/src/core/Box/use-random-classname/use-random-classname.ts
function useRandomClassName() {
	return `__m__-${useId().replace(/[:«»]/g, "")}`;
}
//#endregion
export { useRandomClassName };

//# sourceMappingURL=use-random-classname.mjs.map